import Vue from 'vue';
import App from './App.vue';
import VueGtm from 'vue-gtm';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import apolloProvider from './vue-apollo';

require('./utils/filters.js');
require('./sass/main.scss');
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

import Optimizely from '@/utils/classes/optimizely';

Vue.prototype.$optimizely = new Optimizely();

//onLogin(apolloProvider.defaultClient, 'da2-h4sfryeobvbx5jhkm7x6lslszy');
Vue.config.silent = process.env.NODE_ENV === 'production';

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_PLACES_KEY,
});

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM, // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: true, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.VUE_APP_DEBUG, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

Vue.config.productionTip = false;
new Vue({
  vuetify,
  router,
  store,
  apolloProvider: apolloProvider,
  render: h => h(App),
}).$mount('#app');
